import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { services } from '../../data/services';
import { container, focusRing } from '../../utils/styles';
import { SectionHeading } from '../shared/SectionHeading';
import { ServiceCard } from '../shared/ServiceCard';
export function ServicesOverview() {
  const {
    t
  } = useLanguage();
  return <section className="bg-cream py-20 sm:py-24" aria-labelledby="services-heading" data-id="element-45" data-mp="n6bfm9w60ikm">
      <div className={container} data-id="element-46" data-mp="s7hdem4omw10">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between" data-id="element-47" data-mp="s4czuy5bunxo">
          <SectionHeading id="services-heading" title={t({
          en: 'Our Services',
          es: 'Nuestros Servicios'
        })} intro={t({
          en: 'Comprehensive home care services designed to keep your loved one safe, healthy, and happy in their own home.',
          es: 'Servicios completos de cuidado en el hogar para que tu ser querido esté seguro, sano y feliz en su propia casa.'
        })} data-id="element-48" data-mp="dbjl5exvqbu2" />
          <Link to="/services" className={`inline-flex shrink-0 items-center gap-2 rounded font-semibold text-brand hover:underline ${focusRing}`} data-id="element-49" data-mp="1mx7pxn1rwqm2">
            {t({
            en: 'View all services & pricing',
            es: 'Ver todos los servicios y precios'
          })}
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-50" data-mp="1wn0x8buvujki" />
          </Link>
        </div>
        <ul className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-51" data-mp="18wwue6piqnuk">
          {services.map(service => <li key={service.id} data-id="element-52" data-mp="13zwpw08bht5k">
              <ServiceCard service={service} data-id="element-53" data-mp="1hxuu4csxc97c" />
            </li>)}
        </ul>
      </div>
    </section>;
}